/**
 * @generated SignedSource<<eeb88ec0838b6ed564a690870ae19cd2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EditPipelinePageCancelBuildMutation$variables = {
  buildLocator: string;
};
export type EditPipelinePageCancelBuildMutation$data = {
  readonly cancelBuild: {
    readonly id: number | null | undefined;
  } | null | undefined;
};
export type EditPipelinePageCancelBuildMutation = {
  response: EditPipelinePageCancelBuildMutation$data;
  variables: EditPipelinePageCancelBuildMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "buildLocator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "buildLocator",
    "variableName": "buildLocator"
  },
  {
    "kind": "Literal",
    "name": "input",
    "value": {}
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditPipelinePageCancelBuildMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Build",
        "kind": "LinkedField",
        "name": "cancelBuild",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "EditPipelinePageCancelBuildMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Build",
        "kind": "LinkedField",
        "name": "cancelBuild",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "_id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9e0f56738bb88116fc0bd2aff3fbf1b8",
    "id": null,
    "metadata": {},
    "name": "EditPipelinePageCancelBuildMutation",
    "operationKind": "mutation",
    "text": "mutation EditPipelinePageCancelBuildMutation(\n  $buildLocator: String!\n) {\n  cancelBuild(buildLocator: $buildLocator, input: {}) {\n    id\n    _id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f03cc7acf783ebfd9eebd61a23ef48fb";

export default node;
